export default __webpack_public_path__ + "static/media/add-member.b321df3e.svg";